<script>
  import { onMount, onDestroy } from "svelte";
  export let component;

  onMount(() => {
    let script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-chtml.js";
    script.id = "MathJax-script";
    document.head.append(script);

    script.onload = () => {
      MathJax = {
        tex: {
          inlineMath: [
            ["$", "$"],
            ["\\(", "\\)"],
          ],
        },
        svg: { fontCache: "global" },
      };
    };
  });
  onDestroy(() => {
    let script = document.getElementById("MathJax-script");
    script.remove();
    let styles = document.getElementsByTagName("style"),
      index;
    for (index = styles.length - 1; index >= 0; index--) {
      if (
        styles[index].getAttribute("type") === "text/css" ||
        styles[index].getAttribute("id") === "MJX-CHTML-styles" ||
        styles[index].innerHTML === ""
      ) {
        styles[index].parentNode.removeChild(styles[index]);
      }
    }
  });
</script>

<svelte:component this={component}/>

<style>
</style>